/**
 * @generated SignedSource<<370fad5ad86a951ecd5500c0df2aec6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetailFilter_detailFilter$data = {
  readonly filtercategory: ReadonlyArray<{
    readonly __typename: "DetailFilterDropdownCategory";
    readonly col: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilterDropdownCategory_category">;
  } | {
    readonly __typename: "DetailFilterListCategory";
    readonly col: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilterListCategory_category">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined> | null | undefined;
  readonly selectioninfo: {
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilterSelectionInfo_selectionInfo">;
  } | null | undefined;
  readonly " $fragmentType": "DetailFilter_detailFilter";
};
export type DetailFilter_detailFilter$key = {
  readonly " $data"?: DetailFilter_detailFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetailFilter_detailFilter">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "col",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetailFilter_detailFilter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "filtercategory",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DetailFilterListCategory_category"
            }
          ],
          "type": "DetailFilterListCategory",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DetailFilterDropdownCategory_category"
            }
          ],
          "type": "DetailFilterDropdownCategory",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilterSelectionInfo",
      "kind": "LinkedField",
      "name": "selectioninfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DetailFilterSelectionInfo_selectionInfo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DetailFilter",
  "abstractKey": null
};
})();

(node as any).hash = "0b5ff731892e6949470e502280160787";

export default node;
